import { Instance, SnapshotIn, types } from 'mobx-state-tree';
import { Currency, CurrencyProps } from 'models/reusable-parts/currency';

export interface CalculationProps {
  id: number;
  caption: string;
  amount: CurrencyProps;
}

export const Calculation = types.model({
  id: types.number,
  caption: types.string,
  amount: Currency,
});

export type CalculationSnapshot = SnapshotIn<typeof Calculation>;
export type CalculationInstance = Instance<typeof Calculation>;
